import { gql } from '@apollo/client';

/*******************/
/**     QUERY     **/
/*******************/

/**
 *
 * @param query Query params including device identifier, language, and section to load
 * @param horizontalParams Horizontal pagination parameters
 *
 * Epg by days query
 */
const epgByDays = `epgsByDays(
  query: $query
  horizontalParams: $epgHorizontalParams
) {
    items {
      day
      epgs {
        _id
        ageCode
        category
        actors
        allowRecord
        beginTime
        catchup
        channel
        channelName
        country
        countries {
          countryCode
          localizable {
            en
            es
            ca
          }}
        created
        directors
        duration
        endTime
        episode
        episodeTitle
        eventId
        fastVodEnabled
        gender {
          name
          titles {
            en
            es
            ca
          }
        }
        hosts
        kind
        language
        length
        moviePictures {
          background
          backgroundSrc
          photo
          photoSrc
          poster
          posterSrc
        }
        premiereTVup
        productors
        score
        season
        seasonId
        serieId
        synopsis
        synopsisEpisode
        title
        type
        writers
        year
      }
      totalItems
      pages
    }
  }`;

/**
 *
 * @param query Query params including device identifier, language, and section to load
 * @param epgsHorizontalParams Reels horizontal pagination parameters
 * @returns Section GraphQL query
 */
const query = gql`
  query EpgByDays(
    $query: EpgByDaysQuerySection!
    $epgHorizontalParams: QueryParams!
  ) {
    ${epgByDays}
  }
`;

export default query;
